import { Tag } from "primereact/tag";

import { TAG_SIMULACAO_LABEL } from "./tag-simulacao.constants";
import styles from "./tag-simulacao.module.scss";
import type { TagSimulacaoProps } from "./types-tag-simulacao";

export function TagSimulacaoView({ quebraNoMobile = false }: TagSimulacaoProps) {
  return (
    <Tag
      className={`${styles.tag} ${quebraNoMobile ? styles.quebraNoMobile : ""}`}
      value={TAG_SIMULACAO_LABEL}
      data-testid="tag-simulacao"
    />
  );
}
